import {createContext, useState, useEffect, useContext, useMemo} from "react";

const ProjectContext = createContext(null);

export function ProjectProvider({initialData, children}) {
    const [project, setProject] = useState(initialData);

    useEffect(() => {
        setProject(initialData);
    }, [initialData?.id]); // або initialData?.pid

    const value = useMemo(
        () => ({project, setProject}),
        [project]
    );

    return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

export function useProject() {
    const ctx = useContext(ProjectContext);
    if (!ctx) return {project: null, setProject: () => {}};
    return ctx;
}
